import AssociationContactDetailsEditWrapper from './AssociationContactDetailsEditWrapper.page';

export default AssociationContactDetailsEditWrapper;